import { render } from "./Donate.vue?vue&type=template&id=13c1ef14"
import script from "./Donate.vue?vue&type=script&lang=js"
export * from "./Donate.vue?vue&type=script&lang=js"
script.render = render

export default script